import React, { useState, useContext } from 'react'
import Runs from './Runs'
import Header from './Header'
import { Link, useHistory } from 'react-router-dom'
import { FaArrowLeft, FaSyncAlt, FaPlus} from 'react-icons/fa';
import RunCard from './RunCard';

import './WebRTC/Rtc'
import { getRunById, createRun } from './Firebase';

import { UserContext } from '../Context/Context'




const MultiPlayer = ( {runs, refresh} ) => {

  const {user, setUser} = useContext(UserContext)
  
  const [runid, setRunId] = useState("0")
  const [name, setName] = useState(user.displayName)
  const [highScore, setHighScore] = useState("349m")
  const [players, setPlayers] = useState(0)
  const [profilePicture, setPicture] = useState(user.photoURL)

  const history = useHistory();

  //RUN CLICK EVENT
  const SelectRun = (runId) => {
    var selectedRun = getRunById(runId).then()
    selectedRun.then((res) => {
      selectedRun = res
      setRunId(selectedRun.id)
      setName(selectedRun.player)
      setHighScore(selectedRun.highScore + "m")
      setPlayers(selectedRun.players)
      setPicture(selectedRun.photoURL)
    }).catch(error => {
      alert('This room does not exist')
    })
    
    
  }

  console.log(runid)
  
    return (
      <div className='wrapper'>
        <div className='multiplayerHeader'>
          <Link to="/menu"><FaArrowLeft className='arrow'></FaArrowLeft></Link>
          <Header title="JOIN A RUN"/>
        </div>
        <div className='flex-container'>

          <div className='runs-container'>
            <div className="multiplayer-btn">
              {/* <Button text="Create" color='#616161' onClick={() => {createRun(); refresh()}}></Button> */}
              <FaPlus className='sync' onClick={(e) => {
                ClickHandler(e)
                }}></FaPlus>
              <FaSyncAlt className='sync' style={{marginRight:'0px'}} onClick={() => {refresh()}}></FaSyncAlt>
            </div>
            <div className='runs-span'>
              <div>
                <p>run name</p>
              </div>
              <div>
                <p>runners</p>
              </div>
            </div>
            <Runs runs={runs} onSelect={SelectRun}/>
          </div>

          <div className='runner-container'>
            { runid != 0 ? <RunCard runId={runid} name={name} highscore={highScore} players={players} picture={profilePicture} isLobby={false} ></RunCard> : <h3 style={{margin:"0 auto", maxWidth:"250px"}}>Select a run !</h3>}
          </div>

        </div>
      </div>
    )

    function ClickHandler(e) {
      e.preventDefault();
      createRun().then((doc) => {
        history.push("/lobby#" + doc.id, {Run: doc})
        refresh()
      })
    }
}


MultiPlayer.defaultProps = {
  selectedName: "JOHN WICK"
}

export default MultiPlayer
